import React from 'react';
import { TertiaryButton, WavingHandIcon } from '../AtomComponents';
import { awaitingRule, awardedRule, reofferRule } from '../PreOrders/Utils';
import { NoRowsMatchedComponent } from '../PreOrders/TableCellComponents';

interface IPoOffersEmptyState {
  currentTab: string;
  exportOfferSheet: () => {};
  importOfferSheet: () => void;
  isFiltered?: boolean;
}

const PoOffersEmptyState = ({
  currentTab,
  exportOfferSheet,
  importOfferSheet,
  isFiltered,
}: IPoOffersEmptyState) => {
  if (isFiltered) {
    return (
      <div className="cell small-12 margin-top-2 margin-bottom-2">
        <NoRowsMatchedComponent />
      </div>
    );
  }

  let heading = '';
  if (awardedRule(currentTab)) heading = 'PO Awards';
  if (reofferRule(currentTab)) heading = 'PO Re-Offer Requests';
  if (awaitingRule(currentTab)) heading = 'PO Offers Awaiting Review';

  return (
    <div className="cell margin-top-2 small-12 margin-bottom-2 grid-x">
      <WavingHandIcon className="margin-left-1 margin-right-2 faded_2" fontSize="inherit" />
      <div className="cell small-9">
        <p className="no-awards-heading-text">{`You will see your ${heading} here (nothing yet)`}</p>
        <p>
          Use{' '}
          <TertiaryButton className="no-highlight-on-hover" onClick={exportOfferSheet}>
            EXPORT OFFER SHEET
          </TertiaryButton>{' '}
          to download a spreadsheet of the items currently open for PO Offers.
        </p>
        <p>
          To place PO offers, fill in your PO offers on the downloaded spreadsheet and use{' '}
          <TertiaryButton className="no-highlight-on-hover" onClick={importOfferSheet}>
            IMPORT OFFER SHEET
          </TertiaryButton>
        </p>
      </div>
    </div>
  );
};

export default PoOffersEmptyState;
